// Abstraction for a batch handler, something that accumulates writes in a buffer and flushes batches when instructed
export class BatchWriter<T, U> {
  private readonly buffer: Array<[chunk: T, resolve: (result: U) => void, reject: (reason: unknown) => void]> = [];

  constructor(private readonly consume: (batch: Array<T>) => Promise<U>) {}

  public async write(item: T) {
    return new Promise<U>((resolve, reject) => this.buffer.push([item, resolve, reject]));
  }

  public async flush() {
    const [batch, resolves, rejects] = this.buffer
      .splice(0) // note: synchronously remove from buffer before async processing to avoid dupes
      .reduce<[items: Array<T>, resolvers: Array<(result: U) => void>, rejecters: Array<(reason: unknown) => void>]>(
        ([items, resolvers, rejecters], [item, resolve, reject]) => [
          [...items, item],
          [...resolvers, resolve],
          [...rejecters, reject],
        ],
        [[], [], []],
      );

    if (batch.length) {
      try {
        const result = await this.consume(batch);
        resolves.forEach((resolve) => resolve(result));
      } catch (err) {
        rejects.forEach((reject) => reject(err));
        throw err;
      }
    }
  }
}
